module.exports = __webpack_public_path__ + "static/media/new6-mob@2x.a8c25cbb.png";